var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_251_2925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.5339 62.5333L39.6672 2.8C37.8005 -0.933333 32.6672 -0.933333 30.8005 2.8L0.467206 62.5333C-1.39946 65.8 1.40054 70 5.13387 70H64.8672C68.6005 70 70.9339 65.8 69.5339 62.5333ZM35.0005 60.6667C31.2672 60.6667 28.0005 57.4 28.0005 53.6667C28.0005 49.9333 30.8005 46.6667 35.0005 46.6667C39.2005 46.6667 42.0005 49.9333 42.0005 53.6667C42.0005 57.8667 38.7339 60.6667 35.0005 60.6667ZM39.6672 42H30.3339L28.0005 25.6667C28.0005 24.2667 28.9339 23.3333 30.3339 23.3333H39.6672C41.0672 23.3333 42.0005 24.2667 42.0005 25.6667L39.6672 42Z",
    fill: "#FFC554"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_251_2925"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning_icon.8393f41333cf95ed1c921a3e41395e3c.svg";
export { ForwardRef as ReactComponent };